export { AnimateScrollDirective } from './src/ng2-animate-scroll.directive';
export { AnimateBoxDirective } from './src/ng2-animate-box.directive';
export { AnimateScrollService } from './src/ng2-animate-scroll.service';
export { Ng2AnimateScrollModule } from './src/ng2-animate-scroll.module';
//# sourceMappingURL=ng2-animate-scroll.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-animate-scroll/dist/ng2-animate-scroll.js
// module id = ./node_modules/ng2-animate-scroll/dist/ng2-animate-scroll.js
// module chunks = vendor